import React, { Component } from 'react';
import styled from 'styled-components';

import { Hero } from './Hero';
import Greeting from './Greeting';
import Echo from './Echo';
import GetStarted from './GetStarted';
import FAQ from './FAQ';

const Wrapper = styled.div`
  strong {
    font-weight: bold !important;
  }

  div,
  a,
  p,
  h1,
  h2,
  h3,
  h4,
  h5,
  button {
    font-family: roboto !important;
  }

  h1,
  h2,
  h3,
  h4,
  h5 {
    color: #2f3034 !important;
  }
`;

export class Alexa extends Component {
  render() {
    return (
      <Wrapper>
        <Hero />
        <Greeting />
        <Echo />
        <GetStarted />
        <FAQ />
      </Wrapper>
    );
  }
}
